import { ITheme } from '@fluentui/react';
import Config from 'services/Config/configService';

export enum ImgBgState {
  Initializing = 0,
  LoadingImage = 1,
  LoadingBlob = 2,
  Ready = 8,
  Error = 9,
}

export const imgBgErrorPlaceholder = `${Config.getImageURL()}/sharepoint-page-image-error.png`;
export const spHeaderBgLight = `${Config.getImageURL()}/sharepoint-page-background.png`;
export const spHeaderBgDark = `${Config.getImageURL()}/sharepoint-page-background-dark.png`;

export const getPageEmphasisColor = (emphasis: string | undefined, theme: ITheme): string | undefined => {
  switch (emphasis) {
    case 'neutral':
      return theme.palette.neutralLight;
    case 'soft':
      return theme.palette.themeLighterAlt;
    case 'strong':
      return theme.palette.themePrimary;
    default:
      return undefined;
  }
};
